module.exports = __webpack_public_path__ + "img/icon_db_4.c300fd17.svg";